<template>
    <div>
        <v-dialog v-model="isActive" max-width="490px" scrollable transition="dialog-bottom-transition" persistent>
            <v-card class="rounded-0">
                <v-card flat class="rounded-0">
                    <v-app-bar flat color="white" height="50" class="ma-2">
                        <v-btn v-if="type == 'foto'" icon @click="confirmAndClose(false)">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title class="pr-1 text-h6 font-weight-bold primary--text"
                            style="white-space: normal; word-break: break-word;">{{ title }}</v-toolbar-title>
                    </v-app-bar>
                </v-card>
                <v-card-text class="d-flex flex-column align-center">
                    <component :is="activo" @cerrarDialogo="handleResponse" :msg="msg"></component>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import CardRecordarFoto from '@/components/cards/CardRecordarFoto.vue'
import FormActualizarContacto from '@/components/forms/FormActualizarContacto.vue'

export default {
    name: 'DialogoFaltaFoto',

    components: {
        CardRecordarFoto,
        FormActualizarContacto,
    },

    data() {
        return {
            isActive: false,
            title: '',
            callback: null,
        }
    },
    props: {
        type: {
            type: String,
            default: 'foto',
        },
        msg: {
            type: String,
            required: false,
        }
    },
    computed: {
        activo() {
            switch (this.type) {
                case 'foto':
                    this.title = 'Completá tu legajo'
                    return 'CardRecordarFoto'
                case 'contacto':
                    this.title = 'Confirmá tus datos de contacto'
                    return 'FormActualizarContacto'
                default:
                    break;
            }
        },
    },
    methods: {
        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false
        },
        abrirDialogo() {
            this.isActive = true
            // Devuelve una promesa que se resuelve cuando se cierra el diálogo
            return new Promise(resolve => {
                this.callback = resolve;
            });
        },
        handleResponse(value) {
            // value es el objeto emitido desde CardRecordarFoto
            if (value && value.cerrar) {
                this.$emit('irAEditar', value); // Puedes pasar el objeto completo si lo necesitas
            }
            if (this.callback) {
                this.callback(value);
                this.callback = null;
            }
            this.isActive = false;
        }
    },
}

</script>